<template>
  <div class="apk-list">
    <TopBar />
    <div class="language-selector">
      <div>
        <el-select v-model="apkType" placeholder="选择应用" style="width: 150px" @change="handleLanguageChange">
          <el-option key="ty2502" label="ty2502" value="ty2502"></el-option>
          <el-option key="ty0253" label="ty0253" value="ty0253"></el-option>
        </el-select>
        <el-select v-model="selectedLanguage" placeholder="选择语言区" style="width: 150px;margin-left: 20px" @change="handleLanguageChange">
          <el-option key="zh" label="中文区" value="zh"></el-option>
          <el-option key="en" label="英文区" value="en"></el-option>
          <el-option key="ru" label="俄文区" value="ru"></el-option>
        </el-select>
      </div>

      <el-button type="primary" size="small" @click="handleUpload(null)" style="margin-left: 20px">上传</el-button>
    </div>
    <el-table :data="tableData" style="width: 100%; margin-top: 30px" v-loading="loading">
      <el-table-column prop="apk_type" label="应用" align="center" width="100px"></el-table-column>
      <el-table-column prop="version" label="版本号" align="center"></el-table-column>
      <el-table-column prop="created_at" label="上传日期" align="center">
        <template #default="scope">
          {{ formatDate(scope.row.created_at) }}
        </template>
      </el-table-column>
      <el-table-column prop="min_version" label="可支持上传的最小版本号" align="center"></el-table-column>
      <el-table-column prop="remark" label="版本备注" align="center"></el-table-column>
      <el-table-column label="操作" align="center">
        <template #default="scope">
          <el-button type="text" size="small" @click="handleDownload(scope.row.url)">复制下载链接</el-button>
          <el-button type="text" size="small" @click="handleUpload(scope.row)">替换</el-button>
          <el-button type="text" size="small" @click="handleEditRemark(scope.row)">修改备注</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <div class="pagination" style="width: 100%; margin-top: 20px; text-align: right">
      <div style="float: right; width: 431px">
        <el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" />
      </div>
    </div>

    <!-- 上传弹出框 -->
    <el-dialog v-model="dialogVisible" :title="selectedLanguage === 'zh'
      ? '中文区'
      : selectedLanguage === 'en'
        ? '英文区'
        : '俄文区'
      " width="600px" @close="handleDialogClose">
      <div class="upload-form">
        <div class="form-item" style="margin-bottom: 0px;height: 30px;">
          <label class="form-label">应用:</label>
          <p>{{ apkType }}</p>
        </div>
        <div class="form-item">
          <label class="form-label">版本号:</label>
          <p>{{ displayVersion }}</p>
          <p v-show="!isReplace" style="margin-left: 10px; color: blue; cursor: pointer"
            @click="showVersionInput = true">
            自定义版本
          </p>

          <div v-show="!isReplace && showVersionInput" style="margin-left: 10px">
            <el-input v-model="tempVersion" placeholder="请输入版本号" style="width: 150px; margin: 10px 0"></el-input>
            <el-button style="margin-left: 10px" type="primary" size="small" @click="confirmVersion">确认</el-button>
            <el-button size="small" @click="showVersionInput = false">取消</el-button>
          </div>
        </div>

        <div class="form-item">
          <label class="form-label">版本备注:</label>
          <el-input v-model="uploadForm.versionRemark" type="textarea" rows="3" placeholder="请输入"
            style="width: 250px"></el-input>
        </div>

        <div class="form-item">
          <label class="form-label">最小版本:</label>
          <template v-if="isReplace">
            <p>{{ selectedMinVersion }}</p>
          </template>
          <el-select v-show="!isReplace" v-model="selectedMinVersion" placeholder="选择最小版本" style="width: 250px">
            <el-option v-for="version in versions" :key="version.value" :label="version.label"
              :value="version.value"></el-option>
          </el-select>
        </div>

        <div class="form-item">
          <label class="form-label">文件:</label>
          <div class="file-uploader">
            <el-upload ref="uploadRef" class="upload-demo" drag action="" :on-change="handleFileChange"
              :on-remove="handleFileRemove" :auto-upload="false" :file-list="[]">
              <el-icon class="el-icon--upload"><upload-filled /></el-icon>
              <div class="el-upload__text">文件上传</div>
            </el-upload>
          </div>
        </div>
      </div>

      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="handleSave" :loading="saveLoading">保存</el-button>
          <el-button @click="handleCancel">取消</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 修改备注弹出框 -->
    <el-dialog v-model="remarkDialogVisible" title="修改备注" width="400px" @close="handleRemarkDialogClose">
      <div class="remark-form">
        <div class="form-item">
          <label class="form-label">备注:</label>
          <el-input v-model="remarkForm.remark" placeholder="请输入备注" type="textarea" rows="3"
            style="width: 100%"></el-input>
        </div>
      </div>

      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="handleSaveRemark">保存</el-button>
          <el-button @click="handleRemarkCancel">取消</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { UploadFilled } from "@element-plus/icons-vue";
import TopBar from "./Top.vue";
import { loginApi } from "../api/login";

export default {
  name: "ApkList",
  components: {
    TopBar,
    UploadFilled,
  },
  data() {
    return {
      selectedLanguage: "zh",
      dialogVisible: false,
      displayVersion: "1.0.6",
      showVersionInput: false,
      tempVersion: "",
      selectedMinVersion: "",
      versions: [],
      uploadForm: {
        customVersion: "",
        versionRemark: "",
        file: null,
      },
      currentId: null,
      remarkDialogVisible: false,
      remarkForm: {
        id: null,
        remark: "",
      },
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      loading: false,
      saveLoading: false,
      // 标识当前是上传还是替换操作
      isReplace: false,
      apkType: "ty2502",
    };
  },
  mounted() {
    this.getApkList();
  },
  methods: {
    getCookie(name) {
      const cookieValue = document.cookie
        .split("; ")
        .find((row) => row.startsWith(`${name}=`));
      return cookieValue ? cookieValue.split("=")[1] : null;
    },
    async getApkList() {
      this.loading = true;
      try {
        // 从本地存储获取token，实际项目中可能需要从全局状态管理中获取
        const token = this.getCookie("token") || "";
        console.log("Token:", token);
        console.log("请求参数:", {
          lan: this.selectedLanguage,
          page: this.currentPage,
          limit: this.pageSize,
        });

        const response = await loginApi.getApkList(
          token,
          this.selectedLanguage,
          this.currentPage,
          this.pageSize,
          this.apkType,
        );

        console.log("API响应:", response);

        if (response.code === 200) {
          this.tableData = response.data.data || [];
          this.total = response.data.count || 0;
          console.log("数据加载成功:", {
            total: this.total,
            items: this.tableData.length,
          });
        } else {
          console.error("API返回错误:", response.msg || "未知错误");
          this.$message.error(
            `获取版本列表失败: ${response.msg || "未知错误"}`,
          );
          this.tableData = [];
          this.total = 0;
        }
      } catch (error) {
        console.error("获取APK版本列表失败:", error);
        this.$message.error(`获取版本列表失败: ${error.message || "网络错误"}`);
        this.tableData = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },
    handleLanguageChange() {
      this.currentPage = 1;
      this.getApkList();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.getApkList();
    },
    handleCurrentChange(current) {
      this.currentPage = current;
      this.getApkList();
    },
    async getVersionList() {
      try {
        const token = this.getCookie("token") || "";
        let currentVersion = this.displayVersion;
        // 确保版本号不包含 "V" 前缀
        currentVersion = currentVersion.replace("V", "");
        console.log("获取版本列表参数:", {
          lan: this.selectedLanguage,
          cur: currentVersion,
        });

        const response = await loginApi.getApkVersionList(
          token,
          this.selectedLanguage,
          null,
          this.apkType,
          /* currentVersion ,*/
        );

        console.log("版本列表响应:", response);

        if (response.code === 200) {
          // 转换版本号列表为下拉选项格式
          this.versions = response.data.map((version) => ({
            label: `V${version}`,
            value: version,
          }));
          console.log("版本列表转换后:", this.versions);
        }
      } catch (error) {
        console.error("获取版本列表失败:", error);
        // 失败时使用默认版本列表
        this.versions = [];
      }
    },
    async handleUpload(row = null) {
      // 重置表单数据
      this.showVersionInput = false;
      this.tempVersion = "";
      this.uploadForm = {
        customVersion: "",
        versionRemark: "",
        file: null,
      };
      this.currentId = null;
      this.isReplace = false;
      this.selectedMinVersion = "";

      // 如果有行数据传入，回显数据
      if (row) {
        console.log("回显数据:", row);
        this.currentId = row.id || null;
        this.displayVersion = row.version || "1.0.6";
        this.uploadForm.customVersion = row.version || "";
        this.uploadForm.versionRemark = row.remark || "";
        this.selectedMinVersion = row.min_version || "";
        this.isReplace = true;
      } else {
        // 否则获取下一个版本号
        try {
          const token = this.getCookie("token") || "";
          const response = await loginApi.getNewApkVerNo(token, this.selectedLanguage, this.apkType);
          console.log("获取下一个版本号响应:", response);
          if (response.code === 200) {
            this.displayVersion = response.data || "1.0.6";
          } else {
            console.error("获取下一个版本号失败:", response.msg);
            this.displayVersion = "1.0.6";
          }
        } catch (error) {
          console.error("获取下一个版本号失败:", error);
          this.displayVersion = "1.0.6";
        }
        this.isReplace = false;
      }

      // 获取版本号列表
      await this.getVersionList();

      this.dialogVisible = true;
    },
    async confirmVersion() {
      if (this.tempVersion) {
        this.displayVersion = this.tempVersion;
        this.uploadForm.customVersion = this.tempVersion;
        this.selectedMinVersion = "";
        this.showVersionInput = false;
        this.tempVersion = "";

        // 重新获取版本列表
        await this.getVersionList();
      }
    },
    handleFileChange(file) {
      // 确保正确获取文件对象
      this.uploadForm.file = file.raw || file;
      console.log("文件选择:", this.uploadForm.file);
    },
    handleFileRemove() {
      // 当文件被删除时，清空文件对象
      this.uploadForm.file = null;
      console.log("文件已删除");
    },
    async handleSave() {
      // 验证表单
      if (!this.uploadForm.file) {
        this.$message.error("请选择上传文件");
        return;
      }

      if (!this.displayVersion) {
        this.$message.error("请输入版本号");
        return;
      }

      if (!this.uploadForm.versionRemark) {
        this.$message.error("请输入版本备注");
        return;
      }

      try {
        this.saveLoading = true;
        const token = this.getCookie("token") || "";
        const remark = this.uploadForm.versionRemark;
        const file = this.uploadForm.file;
        let response;

        if (this.isReplace) {
          // 替换操作
          console.log("替换参数:", {
            id: this.currentId,
            remark,
            file,
          });

          // 调用替换API
          response = await loginApi.replaceApk(
            token,
            this.currentId,
            remark,
            file,
          );

          console.log("替换响应:", response);

          if (response.code === 200) {
            this.$message.success("替换成功");
            // 重新获取列表数据
            this.getApkList();
          } else {
            this.$message.error(`替换失败: ${response.msg || "未知错误"}`);
          }
        } else {
          // 上传操作
          // 准备参数
          const version = this.displayVersion;
          const min_version = this.selectedMinVersion || "";
          const lan = this.selectedLanguage;

          console.log("上传参数:", {
            version,
            min_version,
            lan,
            remark,
            file,
          });

          // 调用上传API
          response = await loginApi.uploadApk(
            token,
            version,
            min_version,
            lan,
            remark,
            file,
            this.apkType,
          );

          console.log("上传响应:", response);

          if (response.code === 200) {
            this.$message.success("上传成功");
            // 重新获取列表数据
            this.getApkList();
          } else {
            this.$message.error(`上传失败: ${response.msg || "未知错误"}`);
          }
        }
      } catch (error) {
        console.error("操作失败:", error);
        this.$message.error(`操作失败: ${error.message || "网络错误"}`);
      } finally {
        this.saveLoading = false;
        this.showVersionInput = false;
        this.$nextTick(() => {
          this.dialogVisible = false;
          this.uploadForm.file = null;
          this.currentId = null;
          // 清空上传组件的文件列表
          if (this.$refs.uploadRef) {
            this.$refs.uploadRef.clearFiles();
          }
        });
      }
    },

    handleCancel() {
      this.dialogVisible = false;
      this.uploadForm.file = null;
      this.currentId = null;
      this.isReplace = false;
      this.showVersionInput = false;
      this.tempVersion = "";
      // 清空上传组件的文件列表
      if (this.$refs.uploadRef) {
        this.$refs.uploadRef.clearFiles();
      }
    },
    handleDialogClose() {
      this.showVersionInput = false;
      this.tempVersion = "";
      this.selectedMinVersion = "";
      this.uploadForm.file = null;
      this.currentId = null;
      this.isReplace = false;
      // 清空上传组件的文件列表
      if (this.$refs.uploadRef) {
        this.$refs.uploadRef.clearFiles();
      }
    },
    async handleDownload(url) {
      if (!url) {
        this.$message.error("下载链接不存在");
        return;
      }
      // 移除url中的反引号
      const cleanUrl = url.replace(/`/g, "").trim();
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(cleanUrl);
        } else {
          // 兼容非安全上下文（如 http 环境）
          const textarea = document.createElement("textarea");
          textarea.value = cleanUrl;
          textarea.style.position = "fixed";
          textarea.style.opacity = "0";
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand("copy");
          document.body.removeChild(textarea);
        }
        this.$message.success("下载链接已复制，请在浏览器新标签页打开");
      } catch (error) {
        console.error("复制失败:", error);
        this.$message.error("复制下载链接失败");
      }
    },
    handleEditRemark(row) {
      console.log("修改备注:", row);
      // 回显数据
      this.remarkForm = {
        id: row.id,
        remark: row.remark || "",
      };
      this.remarkDialogVisible = true;
    },
    async handleSaveRemark() {
      try {
        const token = this.getCookie("token") || "";
        console.log("保存备注参数:", this.remarkForm);

        const response = await loginApi.editRemark(
          token,
          this.remarkForm.id,
          this.remarkForm.remark,
        );

        console.log("修改备注响应:", response);

        if (response.code === 200) {
          this.$message.success("修改备注成功");
          // 重新获取列表数据
          this.getApkList();
        } else {
          this.$message.error(`修改备注失败: ${response.msg || "未知错误"}`);
        }
      } catch (error) {
        console.error("修改备注失败:", error);
        this.$message.error(`修改备注失败: ${error.message || "网络错误"}`);
      } finally {
        this.remarkDialogVisible = false;
        this.remarkForm = {
          id: null,
          remark: "",
        };
      }
    },
    handleRemarkCancel() {
      this.remarkDialogVisible = false;
      this.remarkForm = {
        id: null,
        remark: "",
      };
    },
    handleRemarkDialogClose() {
      this.remarkForm = {
        id: null,
        remark: "",
      };
    },
    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      return date.toLocaleString("zh-CN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    },
  },
};
</script>

<style scoped lang="less">
.apk-list {
  padding: 20px;
  padding-top: 60px;
  background-color: #f5f5f5;
  min-height: 100vh;

  h2 {
    margin-bottom: 20px;
    color: #333;
  }
}

.language-selector {
  // margin: 60px 0;
  margin-top: 60px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.upload-form {
  padding: 10px 0;
}

.form-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.form-label {
  display: inline-block;
  width: 80px;
  margin-right: 10px;
  font-size: 14px;
  text-align: right;
}

.version-inputs {
  display: flex;
  align-items: center;
  margin-top: 5px;
}

.current-version,
.target-version {
  font-size: 14px;
  color: #333;
}

.version-arrow {
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 8px solid #666;
  margin: 0 5px;
}

.file-uploader {
  width: 300px;
  margin-top: 10px;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  padding: 40px 20px;
  text-align: center;
  background-color: #fafafa;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 10px;
}

/* 表格内容居中 */
:deep(.el-table__cell) {
  text-align: center;
}
</style>
